import { render, staticRenderFns } from "./MFormMpsStaffPicker.vue?vue&type=template&id=90e73b7e"
import script from "./MFormMpsStaffPicker.vue?vue&type=script&lang=js"
export * from "./MFormMpsStaffPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports